var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"width":_vm.screenWidth<=976?'85%':'964px',"append-to-body":"","show-close":_vm.showClose,"visible":_vm.dialogFormVisible,"close-on-press-escape":false,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"closed":_vm.closeDialog}},[_vm._t("htmlText")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }